/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 6.変数の利用、グラフサイズ */
export const template6 = {
  title: t.to('たくさんの変数の作成と利用', 'title6'),
  desc: t.to(
    '変数に値をセットするブロックで変数を作ると、各ブロックの入力項目で利用するとができます。「=」で書き始めるとその入力項目は「変数の中の値を取り出して使う」という意味になります。',
    'desc6'
  ),
  img: '../public/template/6.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="710" y="190">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="logic_set_value_v2">
        <field name="VAR_NAME">a</field>
        <field name="VALUE">5</field>
        <next>
          <block type="logic_set_value_v2">
            <field name="VAR_NAME">b</field>
            <field name="VALUE">2</field>
            <next>
              <block type="logic_set_value_v2">
                <field name="VAR_NAME">c</field>
                <field name="VALUE">10</field>
                <next>
                  <block type="cube_v2">
                    <field name="id">block1</field>
                    <field name="position-x">-5</field>
                    <field name="position-y">= a / 2</field>
                    <field name="position-z">-6</field>
                    <value name="COLOUR">
                      <shadow type="color_value_v2">
                        <field name="COLOUR">#ff0000</field>
                      </shadow>
                    </value>
                    <value name="ATTR">
                      <block type="scale_v2">
                        <field name="scale-x">1</field>
                        <field name="scale-y">=a</field>
                        <field name="scale-z">1</field>
                      </block>
                    </value>
                    <next>
                      <block type="cube_v2">
                        <field name="id">block2</field>
                        <field name="position-x">0</field>
                        <field name="position-y">= b / 2</field>
                        <field name="position-z">-6</field>
                        <value name="COLOUR">
                          <shadow type="color_value_v2">
                            <field name="COLOUR">#44a655</field>
                          </shadow>
                        </value>
                        <value name="ATTR">
                          <block type="scale_v2">
                            <field name="scale-x">1</field>
                            <field name="scale-y">=b</field>
                            <field name="scale-z">1</field>
                          </block>
                        </value>
                        <next>
                          <block type="cube_v2">
                            <field name="id">block3</field>
                            <field name="position-x">5</field>
                            <field name="position-y">= c / 2</field>
                            <field name="position-z">-6</field>
                            <value name="COLOUR">
                              <shadow type="color_value_v2">
                                <field name="COLOUR">#5a00ff</field>
                              </shadow>
                            </value>
                            <value name="ATTR">
                              <block type="scale_v2">
                                <field name="scale-x">1</field>
                                <field name="scale-y">=c</field>
                                <field name="scale-z">1</field>
                              </block>
                            </value>
                            <next>
                              <block type="environment_v2">
                                <field name="environment">preset:forest</field>
                              </block>
                            </next>
                          </block>
                        </next>
                      </block>
                    </next>
                  </block>
                </next>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>`,
};
